import axios from "axios";
import { COOKIES } from "@/constants/cookies";
import { parseCookies } from "nookies";
import { attachUnauthorizedHandler } from "@/services/interceptors/attach-unauthorized-handler";

export const apiHubspotIntegrationMs = axios.create({
  baseURL: import.meta.env.VITE_HUBSPOT_INTEGRATION_MS,
  headers: {
    "auth-token": parseCookies()[COOKIES.BACKOFFICE_AUTH],
    Authorization: `Bearer ${parseCookies()[COOKIES.BACKOFFICE_AUTH]}`,
  },
});

apiHubspotIntegrationMs.interceptors.request.use((config) => {
  const authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});

attachUnauthorizedHandler(apiHubspotIntegrationMs);
